export default __webpack_public_path__ + "static/media/welcome.c3b48b91.png";